var $592a3fb9261dd6e5$exports = {};
$592a3fb9261dd6e5$exports = {
    "maximum": `\u{6700}\u{5927}`,
    "minimum": `\u{6700}\u{5C0F}`
};


export {$592a3fb9261dd6e5$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
